import { render, staticRenderFns } from "./OchartDialog.vue?vue&type=template&id=0d832b1c&"
import script from "./OchartDialog.vue?vue&type=script&lang=js&"
export * from "./OchartDialog.vue?vue&type=script&lang=js&"
import style0 from "./OchartDialog.vue?vue&type=style&index=0&scpoed=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports